import { StyleProps, CSS } from "@shared/primitive-components"

export const prevPolicyContainer = (props: StyleProps): CSS => ({
  marginRight: props.theme.spacing(6),
  borderLeft: `4px solid ${props.theme.palette.grey.light}`,
  "& ul": {
    right: 0,
  },
  "@media only screen and (max-width: 800px)": {
    borderLeft: `none`,
  },
})

export const prevPolicyTrigger = (): CSS => ({
  fontSize: `15px`,
})

export const prevPolicyContent = (): CSS => ({
  background: `#000`,
  color: `#fff`,
})

export const prevPolicyItem = (): CSS => ({
  color: `#fff`,
})

export const prevPolicyTitle = (): CSS => ({
  minWidth: `140px`,
  margin: `0 15px 0 28px`,
  "@media only screen and (max-width: 800px)": {
    display: `none`,
  },
})
